import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Notification } from '@app/models/notifications/notifications.model';

@Component({
    selector: 'app-general-notification',
    templateUrl: './general.component.html',
    styleUrls: ['../notification-types.scss'],
})
export class GeneralNotificationComponent implements OnInit {
    @Input() notification: Notification = null;
    @Output() markedRead = new EventEmitter();
    @Output() deleteNotification = new EventEmitter();

    constructor() {}

    ngOnInit() {}
}
